import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../../services/api.service";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-create-view-wishlist',
  templateUrl: './create-view-wishlist.component.html',
  styleUrls: ['./create-view-wishlist.component.scss'],
  standalone: false
})
export class CreateViewWishlistComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Wishlist', path: 'app/users/dashboard/wishlist-home'},
    { label: 'Wishlist Entry Details'}
  ];

  savedFeedbackTitle: string = '';
  savedFeedbackTxt: string = '';
  savedFeedbackType: string = '';
  savedFeedbackStatus: string = '';

  feedbackTypesList: any[] = [];

  feedbackObj: any = {};

  username: string = '';
  userId: number = -1;
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  create: boolean = true;

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
  }

  ngOnInit(): void {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    // @ts-ignore
    this.userId = this.auth2ServiceChild.getUserId();
    const browserUrl = window.location.href;

    if (!this.username) {
      this.routerChild.navigateByUrl('app/login');
    }
    if (browserUrl.includes('wishlist') && browserUrl.includes('view')) {
      this.titleService.setTitle("Scalanthropy View Wishlist Entry");
      this.create = false;
      const feedbackId = this.route.snapshot.paramMap.get('feedbackId');
      if (feedbackId) {
        this.userService.getWishlistEntryDetails(this.username, parseInt(feedbackId), this.impersonatedEmail).subscribe(
          (result2: any) => {
            if (result2 && result2.body) {
              this.feedbackObj = result2.body;
              this.savedFeedbackTitle = this.feedbackObj.feedbackTitleTxt;
              this.savedFeedbackType = this.feedbackObj.feedbackTypeDto.feedbackTypeDisplayName;
              this.savedFeedbackTxt = this.feedbackObj.feedbackTxt;
            }
          }, (err2: HttpErrorResponse) => {
            this.redirectToLogin(err2);
            this.pageErrorMessages.push({
              field: 'Feedback API Error',
              detail: 'Failed to pull wishlist entry details....',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
          }
        );
      }
    }
    if (this.create) {
      this.titleService.setTitle("Scalanthropy Create Wishlist Entry");
      this.userService.getFeedbackTypes(this.username).subscribe(
        (result: any) => {
          if (result && result.body) {
            this.feedbackTypesList = result.body;
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Feedback API Error',
            detail: 'Could not download Feedback Type Drop down list...',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        })
      }
    }

  onSubmit(): any {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    //Obtain userId
    if (!this.userId) {
      this.pageErrorMessages.push({
        field: 'UserId Error',
        detail: 'UserID: ' + this.userId + ' is not found.',
        severity: 'error'
      });
    }
    const feedbackTitleTxtEl = document.getElementById('feedback-title-txt-id');
    // @ts-ignore
    let feedbackTitleTxt = feedbackTitleTxtEl.value;
    if (!feedbackTitleTxt) {
      this.pageErrorMessages.push({
        field: 'Feedback Title',
        detail: 'Feedback Title: ' + feedbackTitleTxt + ' is not valid.',
        severity: 'error'
      });
    }
    //Obtain New Password
    const feedbackTextAreaEl = document.getElementById('feedback-textarea-txt-id');
    // @ts-ignore
    let feedbackTextArea: string = feedbackTextAreaEl.value;
    if (!feedbackTextArea) {
      this.pageErrorMessages.push({
        field: 'Feedback Error',
        detail: 'You must submit feedback in this form.',
        severity: 'error'
      });
    }

    //Obtain New Password
    const feedbackTypeDropdownEl = document.getElementById('feedback-type-dropdown-list-id');
    // @ts-ignore
    const feedbackTypeName: string = feedbackTypeDropdownEl.value;
    if (!feedbackTypeName) {
      this.pageErrorMessages.push({
        field: 'feedbackTypeName',
        detail: 'feedbackTypeName: ' + feedbackTypeName + ' is not valid.',
        severity: 'error'
      })
    }

    let feedbackTypeDto: any = {

    }
    for (const feedbackTypeTemp of this.feedbackTypesList) {
      if (feedbackTypeTemp.feedbackTypeName == feedbackTypeName) {
        feedbackTypeDto = feedbackTypeTemp;
      }
    }

    if (this.pageErrorMessages.length > 0) {
      this.showPageErrorMessagesToUser();
      return;
    }
    feedbackTitleTxt = this.apiService.removeControlChar(feedbackTitleTxt);
    feedbackTextArea = this.apiService.escapeOutput(feedbackTextArea);

    let feedbackDto: any = {
      feedbackId : -1,
      userId: this.userId,
      statusLookupDto: null,
      feedbackTitleTxt: feedbackTitleTxt,
      feedbackTypeDto: feedbackTypeDto,
      feedbackTxt: feedbackTextArea,
      createdTS: '',
      updatedTS: '',
      reviewedBy: ''
    }

    this.userService.createWishlistEntry(this.username, feedbackDto, this.impersonatedEmail)
      .subscribe( (result: any) => {
        if (result && result.body) {
          this.routerChild.navigateByUrl('app/users/dashboard/wishlist-home');
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        console.log('createWishlistEntry: ' + JSON.stringify(err));
        if (err.error.limitReached && err.error.limitReached == 'Y') {
          this.pageErrorMessages.push({
            field: 'Wishlist Entry Failure',
            detail: 'Woah-whoah! You have reached your limit of: ' + err.error.limitAmount + ' entries.',
            severity: 'error'
          });
        } else {
          this.pageErrorMessages.push({
            field: 'Wishlist Entry Failure',
            detail: 'Failed to create Wishlist Entry: ' + err.error.message,
            severity: 'error'
          });
        }
        this.showPageErrorMessagesToUser();
      });
  }

  onCancel(): any {
    this.routerChild.navigateByUrl('app/users/dashboard/wishlist-home');
  }
}
